import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  result: string;
  quote: string;
  image?: string;
}
export function TestimonialCard({
  name,
  location,
  result,
  quote,
  image
}: TestimonialCardProps) {
  return <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300" data-id="element-16">
      <div className="flex gap-1 mb-4" role="img" aria-label="5 stars" data-id="element-17">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" aria-hidden="true" data-id="element-18" />)}
      </div>

      <p className="text-gray-300 mb-4 leading-relaxed" data-id="element-19">"{quote}"</p>

      <div className="border-t border-zinc-800 pt-4 flex items-center gap-4" data-id="element-20">
        {image && <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover border-2 border-cyan-500/50" data-id="element-21" />}
        <div data-id="element-22">
          <p className="font-bold text-white" data-id="element-23">{name}</p>
          <p className="text-sm text-gray-400" data-id="element-24">{location}</p>
          <p className="text-cyan-400 font-semibold mt-1 text-sm" data-id="element-25">{result}</p>
        </div>
      </div>
    </div>;
}